/*
  BKM: variantval bara vid engångsköp (22 okt 2026)
  - När en prenumeration (återkommande selling plan) är vald i Recharge-widgeten:
    burk-varianten (SKU 1xxx) väljs automatiskt och variantväljaren döljs.
  - Vid engångsköp visas variantväljaren igen.
  - Skyddsnät: om formuläret skickas med prenumeration + refill byts id till burken.
*/
(function () {
  'use strict';
  if (window.__bkmSubVariantLock) return;
  window.__bkmSubVariantLock = true;

  var DEBUG = /bkm_debug=1/.test(location.search);
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[BKM-SUB-LOCK]'].concat([].slice.call(arguments))); }

  var LOCK_CLASS = 'bkm-sub-locked';
  var REFILL_RE = /(refill|bag|påfyllning|pafyllning|påse|pase|pouch)/i;
  var JAR_RE = /(can|jar|burk|container|tub)/i;

  function getProductJson() {
    var el = document.querySelector('script[data-product-json]') || document.querySelector('script[id^="ProductJson"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var product = getProductJson();
  if (!product || !product.variants || product.variants.length < 2) { log('ingen produkt / bara en variant'); return; }

  // Återkommande planer (inte Preorder)
  var recurring = {};
  (product.selling_plan_groups || []).forEach(function (g) {
    (g.selling_plans || []).forEach(function (p) { if (p.recurring_deliveries !== false) recurring[String(p.id)] = true; });
  });
  if (!Object.keys(recurring).length) { log('inga återkommande planer'); return; }

  function findJar() {
    var v = product.variants;
    var bySku = v.filter(function (x) { return x.sku && /^1/.test(String(x.sku)); });
    if (bySku.length) return bySku[0];
    var byName = v.filter(function (x) { return JAR_RE.test(x.title || '') && !REFILL_RE.test(x.title || ''); });
    if (byName.length) return byName[0];
    var notRefill = v.filter(function (x) { return !REFILL_RE.test(x.title || ''); });
    return notRefill[0] || v[0];
  }
  var jar = findJar();
  if (!jar) return;
  var JAR_ID = String(jar.id);
  // Om burken är slutsåld låter vi sidan vara som förut (annars blir det en återvändsgränd:
  // slutsåld burk + dold variantväljare + dold Recharge-widget).
  if (jar.available === false) { log('burken är slutsåld, låset är avstängt på denna produkt', JAR_ID); return; }
  log('burk', JAR_ID, jar.sku, jar.title);

  function productForms() {
    return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
      var pid = f.querySelector('input[name="product-id"]');
      return !pid || String(pid.value) === String(product.id);
    });
  }
  function mainForm() { return productForms()[0] || null; }

  function currentVariantId() {
    var f = mainForm();
    var i = f && f.querySelector('[name="id"]');
    return i ? String(i.value) : '';
  }
  function currentPlanId() { return planOf(mainForm()); }
  function planOf(f) {
    if (!f) return '';
    // Recharge-widgeten skriver till ett dolt fält. Temats egna (dolda) radioknappar räknas bara om de är ikryssade.
    var inputs = f.querySelectorAll('input[name="selling_plan"]');
    var hidden = null, checked = '';
    for (var k = 0; k < inputs.length; k++) {
      var t = (inputs[k].type || '').toLowerCase();
      if (inputs[k].disabled) continue;
      if (t === 'radio' || t === 'checkbox') { if (inputs[k].checked && inputs[k].value && !checked) checked = String(inputs[k].value); }
      else if (hidden === null) hidden = String(inputs[k].value || '');
    }
    var sel = f.querySelector('select[name="selling_plan"]');
    if (hidden !== null) return hidden;
    if (checked) return checked;
    return sel ? String(sel.value || '') : '';
  }
  function isSubscription(planId) { return !!(planId && recurring[String(planId)]); }

  function pickers() {
    var list = [];
    document.querySelectorAll('.enhanced-variant-selector').forEach(function (el) {
      var dp = el.getAttribute('data-product-id');
      if (dp && String(dp) !== String(product.id)) return;
      list.push(el.closest('.product__block') || el);
    });
    productForms().forEach(function (f) { f.querySelectorAll('.product__selectors').forEach(function (s) { list.push(s); }); });
    document.querySelectorAll('[data-bkm-variant-picker]').forEach(function (el) { list.push(el); });
    return list;
  }

  // Leta i (nästlade) shadow roots
  function deepQueryAll(root, sel, out) {
    out = out || [];
    if (!root) return out;
    try { root.querySelectorAll(sel).forEach(function (n) { out.push(n); }); } catch (e) {}
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) { if (all[i].shadowRoot) deepQueryAll(all[i].shadowRoot, sel, out); }
    return out;
  }

  function reselectPlan(planId) {
    if (!planId || currentPlanId() === String(planId)) return;
    var widgets = document.querySelectorAll('recharge-subscription-widget, recharge-quantity-upsell');
    for (var w = 0; w < widgets.length; w++) {
      var inputs = deepQueryAll(widgets[w].shadowRoot || widgets[w], 'input[value="' + planId + '"]');
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].checked) { log('återväljer plan', planId); inputs[i].click(); return; }
      }
      var selects = deepQueryAll(widgets[w].shadowRoot || widgets[w], 'select');
      for (var s = 0; s < selects.length; s++) {
        var opt = selects[s].querySelector('option[value="' + planId + '"]');
        if (opt) { selects[s].value = String(planId); selects[s].dispatchEvent(new Event('change', { bubbles: true, composed: true })); return; }
      }
    }
  }

  var switching = false;
  function selectJar(planToKeep) {
    if (currentVariantId() === JAR_ID || switching) return;
    switching = true;
    log('byter till burk', JAR_ID);
    var btn = document.querySelector('.enhanced-variant-button[data-variant-id="' + JAR_ID + '"]');
    if (btn) {
      btn.click();
    } else {
      var opt = (jar.options && jar.options[0]) || jar.option1;
      var radio = null;
      document.querySelectorAll('[data-single-option-selector]').forEach(function (r) { if (r.value === opt) radio = r; });
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      productForms().forEach(function (f) {
        var i = f.querySelector('[name="id"]');
        if (i && String(i.value) !== JAR_ID) {
          i.value = JAR_ID;
          if (i.tagName === 'INPUT') i.setAttribute('value', JAR_ID);
          i.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    // Widgeten kan rendera om vid variantbyte: se till att samma plan fortfarande är vald
    [150, 500, 1200].forEach(function (ms) { setTimeout(function () { reselectPlan(planToKeep); }, ms); });
    setTimeout(function () { switching = false; }, 600);
  }

  // ---- Prenumerationspriser alltid från burken ----
  // När en annan variant (refill) är vald för engångsköp visar Recharge-widgeten refill-priser
  // på prenumerationsraderna. Vi skriver om dem till burkens pris (samma antal och format som widgeten).
  function allocMap(v) {
    var m = {};
    ((v && v.selling_plan_allocations) || []).forEach(function (a) { m[String(a.selling_plan_id)] = a; });
    return m;
  }
  var jarAlloc = allocMap(jar);
  function variantById(id) {
    for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(id)) return product.variants[i];
    return null;
  }
  function parseMoney(txt) {
    var m = String(txt).match(/\d[\d.,\s\u00a0\u202f']*\d|\d/);
    if (!m) return null;
    var raw = m[0], decSep = null, decimals = 0;
    var dm = raw.match(/([.,])(\d{1,2})$/);
    if (dm && !(dm[2].length === 3)) {
      // Separator följd av 1-2 siffror i slutet = decimaler (tusentalsavgränsare har alltid 3)
      decSep = dm[1]; decimals = dm[2].length;
    }
    var intPart = decSep ? raw.slice(0, raw.length - decimals - 1) : raw;
    var thouMatch = intPart.match(/[^\d]/);
    var thouSep = thouMatch ? thouMatch[0] : '';
    var num = parseFloat(intPart.replace(/[^\d]/g, '') + (decSep ? '.' + dm[2] : ''));
    return { raw: raw, index: m.index, value: num, decSep: decSep, decimals: decimals, thouSep: thouSep };
  }
  function formatLike(p, value) {
    var fixed = value.toFixed(p.decimals);
    var parts = fixed.split('.');
    var intStr = parts[0];
    if (p.thouSep) intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, p.thouSep);
    else if (/\s|\u00a0|\u202f/.test(p.raw)) intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return parts.length > 1 ? intStr + (p.decSep || '.') + parts[1] : intStr;
  }
  function priceTextNode(row) {
    var el = row.querySelector('.rc-quantity-upsell-option__header > div:last-child') ||
             row.querySelector('[class*="price"]:not([class*="badge"])');
    if (!el) return null;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n, last = null;
    while ((n = walker.nextNode())) { if (/\d/.test(n.nodeValue)) last = n; }
    return last;
  }
  function overrideSubPrices() {
    var vid = currentVariantId();
    if (!vid || vid === JAR_ID) return;
    var cur = variantById(vid);
    if (!cur) return;
    var curAlloc = allocMap(cur);
    var widgets = document.querySelectorAll('recharge-subscription-widget');
    for (var w = 0; w < widgets.length; w++) {
      var radios = deepQueryAll(widgets[w].shadowRoot || widgets[w], 'input[type="radio"]');
      radios.forEach(function (r) {
        var pid = String(r.value || '');
        if (!pid || !recurring[pid]) return;
        var a = curAlloc[pid], j = jarAlloc[pid];
        if (!a || !j || !a.per_delivery_price) return;
        var row = r.closest('.rc-quantity-upsell-option, .rc-purchase-option, label') || r.parentElement;
        if (row && row.getAttribute && row.getAttribute('data-bkm-bundle')) return; // bkm-bundle-cart.js sätter bundlens pris
        var tn = row && priceTextNode(row);
        if (!tn) return;
        if (tn.__bkmWritten === tn.nodeValue) return; // redan omskriven, widgeten har inte ändrat texten
        var p = parseMoney(tn.nodeValue);
        if (!p || !p.value) return;
        var qty = Math.max(1, Math.round((p.value * 100) / a.per_delivery_price));
        var jarValue = (qty * j.per_delivery_price) / 100;
        var next = tn.nodeValue.slice(0, p.index) + formatLike(p, jarValue) + tn.nodeValue.slice(p.index + p.raw.length);
        if (next !== tn.nodeValue) { log('pris', pid, tn.nodeValue, '->', next); tn.nodeValue = next; }
        tn.__bkmWritten = tn.nodeValue;
      });
    }
  }
  var observed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function observeWidgets() {
    if (!observed || !window.MutationObserver) return;
    document.querySelectorAll('recharge-subscription-widget').forEach(function (w) {
      var roots = [w.shadowRoot].concat(deepQueryAll(w.shadowRoot || w, '*').map(function (e) { return e.shadowRoot; }));
      roots.forEach(function (r) {
        if (!r || observed.has(r)) return;
        observed.add(r);
        new MutationObserver(function () { overrideSubPrices(); }).observe(r, { childList: true, subtree: true, characterData: true });
      });
    });
  }

  var lastPlan = null;
  var lastLocked = null;
  function apply() {
    var plan = currentPlanId();
    var sub = isSubscription(plan);
    if (sub) lastPlan = plan;
    if (sub !== lastLocked) {
      lastLocked = sub;
      document.documentElement.classList.toggle(LOCK_CLASS, sub);
      log(sub ? 'prenumeration vald, låser burk' : 'engångsköp, visar variantväljare', plan);
    }
    pickers().forEach(function (p) {
      if (sub) { p.setAttribute('data-bkm-sub-hidden', ''); p.setAttribute('aria-hidden', 'true'); }
      else if (p.hasAttribute('data-bkm-sub-hidden')) { p.removeAttribute('data-bkm-sub-hidden'); p.removeAttribute('aria-hidden'); }
    });
    if (sub && currentVariantId() !== JAR_ID) selectJar(plan);
    observeWidgets();
    overrideSubPrices();
  }

  // CSS
  var css = document.createElement('style');
  css.id = 'bkm-sub-variant-lock-css';
  css.textContent = '[data-bkm-sub-hidden]{display:none !important;}';
  document.head.appendChild(css);

  // Skyddsnät vid köp: prenumeration ska alltid vara burken
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (productForms().indexOf(f) === -1) return;
    var idI = f.querySelector('[name="id"]');
    if (isSubscription(planOf(f)) && idI && String(idI.value) !== JAR_ID) {
      log('skyddsnät: byter id till burk vid submit');
      idI.value = JAR_ID;
    }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-add-to-cart], button[name="add"]');
    if (!b) return;
    var f = b.closest('form[action*="/cart/add"]') || mainForm();
    if (!f || productForms().indexOf(f) === -1) return;
    var idI = f.querySelector('[name="id"]');
    if (isSubscription(planOf(f)) && idI && String(idI.value) !== JAR_ID) {
      log('skyddsnät: byter id till burk vid klick på köpknapp');
      idI.value = JAR_ID;
    }
  }, true);

  // Lyssna på Recharge-widgetens händelser + vanliga ändringar, plus en lätt kontroll var 400 ms
  ['planChange', 'quantityUpsellChange', 'change', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(apply, 0); setTimeout(apply, 120); }, true);
  });
  function start() { apply(); setInterval(apply, 400); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
